import React, { Component } from 'react';
import { Box, Paper, Grid } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import AdvancesList from '../Advances/AdvancesList';
import PaymentsList from './PaymentsList';
import SearchBar from '../../common/SearchBar';
import { InputSelectMulti } from '../../common/Form';
import TitleWithEndAction from '../../common/TitleWithEndAction';

class PaymentsGeneral extends Component {
    state = { 
        searchBank: [],
        searchBar: "",
        searchUser: [],
        searchMode: [],
        searchSupplier: [],
        index: 0,
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    handleChangeMulti = (option, field) => {
        if(option){
            this.setState({                
                [field]: option,
            })
        } else {
            this.setState({
                [field]: [],
            })
        }
    }
    render() {
        const { BANKS, USERS, SUPPLIERS } = this.props;
        return (
            <Box>
                <TitleWithEndAction
                    title="Liste des Paiements"
                    action={() => this.props.openFormDownload("/extract/payments")}
                    actionTitle="Télécharger" 
                    disabled={this.props.downloading}
                />
                <Paper >
                    <Box p={2} >
                        <Grid container >
                            <Grid item xs={12} sm={6} >
                                <InputSelectMulti
                                    label="Banque"
                                    name="searchBank"
                                    value={this.state.searchBank}
                                    labelWidth={60} 
                                    options={Object.values(BANKS).map( item => ({
                                        label: item.bank_name,
                                        value: item.bank_id,
                                        disabled: Array.isArray(this.state.searchBank) && !!this.state.searchBank.find(element => element.value === item.bank_id)
                                    }))}
                                    onChange={(option) => this.handleChangeMulti(option, "searchBank")}
                                    isMulti
                                />
                            </Grid>  
                            <Grid item xs={12} sm={6} >
                                <SearchBar 
                                    handleChange={this.handleChange} 
                                    label="Référence Paiement"
                                    searchValue={this.state.searchBar}
                                    name="searchBar"
                                />
                            </Grid>   
                            <Grid item xs={12} sm={6} >
                                <InputSelectMulti
                                    label="Mode de Paiement"
                                    name="searchMode"
                                    value={this.state.searchMode}
                                    onChange={(option) => this.handleChangeMulti(option, "searchMode")}
                                    options={[
                                        "ESPECES",
                                        "CHEQUE",
                                        "PRELEVEMENT",
                                        "VIREMENT",
                                        "GAB",
                                        "MOBILE MONEY",
                                        "COLLAB",
                                        "ACOMPTE",
                                    ].map((mode) => ({
                                        label: mode,
                                        value: mode,
                                        disabled: Array.isArray(this.state.searchMode) && !!this.state.searchMode.find((element) => element.value === mode)
                                    }))}
                                    isMulti
                                />
                            </Grid>  
                            {/* {this.state.index === 0 && */}
                            <Grid item xs={12} sm={6} >
                                <InputSelectMulti
                                    label="Utilisateur"
                                    id="searchUser"
                                    options={Object.values(USERS).map( item => ({
                                        label: `${item.email} - ${item.lastname.toUpperCase()} ${item.username}`,
                                        value: item.user_id,
                                        disabled: Array.isArray(this.state.searchUser) && !!this.state.searchUser.find(element => element.value === item.user_id)
                                    }))}
                                    value={this.state.searchUser}
                                    onChange={(option) => this.handleChangeMulti(option, "searchUser")}
                                    isMulti
                                />
                            </Grid>  
                            {/* } */}
                            {/* <Grid item xs={12} sm={6} >
                                <InputSelectMulti
                                    label="Fournisseur"
                                    id="searchSupplier"
                                    options={Object.values(SUPPLIERS).map( item => ({
                                        label: `${item.supplier_name}`,
                                        value: item.supplier_id,
                                        disabled: Array.isArray(this.state.searchSupplier) && !!this.state.searchSupplier.find(element => element.value === item.supplier_id)
                                    }))}
                                    value={this.state.searchSupplier}
                                    onChange={(option) => this.handleChangeMulti(option, "searchSupplier")}
                                    isMulti
                                />
                            </Grid>   */}
                        </Grid>  
                    </Box>  
                </Paper>
                <PaymentsList
                    {...this.props}
                    {...this.state}
                    handleChange={this.handleChange}
                />
                {/* <SwipeableTabs
                    returnIndex={(index) => this.setState({ index })}
                    labels={["Paiements", "Acomptes"]}
                > */}
                    {/* <AdvancesList
                        {...this.props}
                        {...this.state}
                        handleChange={this.handleChange}
                    />
                </SwipeableTabs> */}
            </Box>
        );
    }
}

export default PaymentsGeneral;